export const Configuration = Object.freeze({
  api: import.meta.env.VITE_API || '',
  adminDomains: import.meta.env.VITE_ADMIN_DOMAINS.trim() ? import.meta.env.VITE_ADMIN_DOMAINS.split(',') : [],
  agGridLicense: import.meta.env.VITE_AG_GRID_LICENSE || '',
  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID || '',
  applicationInsightsKey: import.meta.env.VITE_APPLICATION_INSIGHTS_KEY || '',
  storage: import.meta.env.VITE_STORAGE || 'localStorage',
  mailtoHelp: import.meta.env.VITE_MAILTO_HELP || '',
  disableAnalytics: import.meta.env.VITE_DISABLE_ANALYTICS || true,
  version: import.meta.env.VITE_VERSION || 'Local',
  enableBuildNumberInUI: (import.meta.env.VITE_ENABLE_BUILD_NUMBER_IN_UI || '').toLowerCase() === 'true',
  clientId: import.meta.env.VITE_CLIENT_ID || '',
  clientSecret: import.meta.env.VITE_CLIENT_SECRET || '',
  msalClientId: import.meta.env.VITE_MSAL_CLIENT_ID || '',
  msalAuthority: import.meta.env.VITE_MSAL_AUTHORITY || '',
  msalRedirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI || '',
  heapAnalyticsAppId: import.meta.env.VITE_HEAP_ANALYTICS_APP_ID || '',
  useHeapAnalytics: import.meta.env.VITE_USE_HEAP_ANALYTICS || false,
  plannerDataSitePlanId: import.meta.env.VITE_PLANNER_DATASITE_PLANID || '',
  plannerMnpiDataSitePlanId: import.meta.env.VITE_PLANNER_MNPI_DATASITE_PLANID || '',
  plannerDataSiteEmailBucketId: import.meta.env.VITE_PLANNER_DATASITE_EMAIL_BUCKETID || '',
  plannerDataSiteMissingEmailBucketId: import.meta.env.VITE_PLANNER_DATASITE_MISSING_EMAIL_BUCKETID || '',
  plannerMnpiDataSiteMissingEmailBucketId: import.meta.env.VITE_PLANNER_MNPI_DATASITE_MISSING_EMAIL_BUCKETID || '',
  plannerDataSiteRogueBucketId: import.meta.env.VITE_PLANNER_DATASITE_ROGUE_BUCKETID || '',
  plannerCallTranscriptPendingBucketId: import.meta.env.VITE_PLANNER_CALL_TRANSCRIPT_PENDING_BUCKETID || '',
  plannerCallTranscriptNeedsApprovalBucketId:
    import.meta.env.VITE_PLANNER_CALL_TRANSCRIPT_NEEDS_APPROVAL_BUCKETID || '',
  plannerMnpiDataSiteEmailBucketId: import.meta.env.VITE_PLANNER_MNPI_DATASITE_EMAIL_BUCKETID || '',
  plannerMnpiDataSiteRogueBucketId: import.meta.env.VITE_PLANNER_MNPI_DATASITE_ROGUE_BUCKETID || '',
  plannerMnpiCallTranscriptPendingBucketId: import.meta.env.VITE_PLANNER_MNPI_CALL_TRANSCRIPT_PENDING_BUCKETID || '',
  plannerMnpiCallTranscriptNeedsApprovalBucketId:
    import.meta.env.VITE_PLANNER_MNPI_CALL_TRANSCRIPT_NEEDS_APPROVAL_BUCKETID || '',
  plannerDataSiteGroupId: import.meta.env.VITE_PLANNER_DATASITE_GROUPID || '',
  plannerMnpiDataSiteGroupId: import.meta.env.VITE_PLANNER_MNPI_DATASITE_GROUPID || '',
  plannerTaskUrl: import.meta.env.VITE_PLANNER_TASK_URL || '',
  /** 
   * Required for Bixby versus Bixby Admin in CreditSights distinction.
  */
  isStandAloneMode: (import.meta.env.VITE_STAND_ALONE_MODE || '').toLowerCase() === 'true',
  releaseFeatureFlagPublicCompanies: import.meta.env.VITE_RELEASE_FEATURE_FLAG_PUBLIC_COMPANIES,
  releaseFeatureFlagClos: import.meta.env.VITE_RELEASE_FEATURE_FLAG_CLOS,
  releaseFeatureFlagDocumentHosting: import.meta.env.VITE_RELEASE_FEATURE_FLAG_DOCUMENTHOSTING,
  releaseFeatureFlagCompanyHistory: import.meta.env.VITE_RELEASE_FEATURE_FLAG_COMPANYHISTORY,
  releaseFeatureFlagBixbyCompliance: import.meta.env.VITE_RELEASE_FEATURE_FLAG_BIXBYCOMPLIANCE,
  releaseFeatureFlagCreditSightsCovenantReview: import.meta.env.VITE_RELEASE_FEATURE_FLAG_CREDITSIGHTS_COVENANT_REVIEW,
  releaseFeatureFlagCompanyComps: import.meta.env.VITE_RELEASE_FEATURE_FLAG_COMPANY_COMPS,
  releaseFeatureFlagCreditSightsNewsIntegration: import.meta.env
    .VITE_RELEASE_FEATURE_FLAG_CREDITSIGHTS_NEWS_INTEGRATION,
  releaseFeatureFlagCreditSightsTranscriptionsIntegration: import.meta.env
    .VITE_RELEASE_FEATURE_FLAG_CREDITSIGHTS_TRANSCRIPTIONS_INTEGRATION,
  releaseFeatureFlagHistoricalFinancialModels: import.meta.env.VITE_RELEASE_FEATURE_FLAG_HISTORICAL_FINANCIAL_MODELS,
  releaseFeatureFlagSFDR: import.meta.env.VITE_RELEASE_FEATURE_FLAG_SFDR,
  releaseFeatureFlagTreppCLO: import.meta.env.VITE_RELEASE_FEATURE_FLAG_TREPPCLO,
  releaseFeatureFlagCloPermissioning: import.meta.env.VITE_RELEASE_FEATURE_FLAG_CLO_PERMISSIONING,
  releaseFeatureFlagClientProvidedDataSites: import.meta.env.VITE_RELEASE_FEATURE_FLAG_CLIENT_PROVIDED_DATA_SITES,
  privacyPolicyUrl: import.meta.env.VITE_PRIVACYPOLICY_URL,
  termsOfServiceUrl: import.meta.env.VITE_TERMSOFSERVICE_URL,
  creditSightsUrl: import.meta.env.VITE_CREDITSIGHTS_URL,
  cutoverLimit: Number(import.meta.env.VITE_CUTOVER_LIMIT),
});
